import D from "./dialog";
import Prompt from "./prompt";
import Confirm from "./confirm";
import Alert from "./alert";

const Dialog = D;
export { D, Prompt, Confirm, Alert, Dialog };
export default D;

export * from "./alert";
export * from "./confirm";
export * from "./media-dialog";
